import React, { useState } from "react";
import { MdCheckCircle, MdHourglassTop, MdRefresh } from "react-icons/md";
import { _userProfile } from "Services/api";
import SectionCard from "components/card/SectionCard";
import { clearAdminSession, getStoredUser, storeAdminSession } from "utils/session";

const PendingApproval = () => {
  const [account, setAccount] = useState(getStoredUser());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const isApproved = account?.is_active === true;

  const refreshStatus = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await _userProfile(sessionStorage.getItem("VendorToken"));
      const nextAccount = storeAdminSession(response?.data || {});
      setAccount(nextAccount);
    } catch (statusError) {
      setError(statusError?.response?.data?.message || "Could not refresh approval status.");
    } finally {
      setLoading(false);
    }
  };

  const signInAgain = () => {
    clearAdminSession();
    window.location.href = "/admin/auth/sign-in";
  };

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-5 py-8">
      <SectionCard extra="overflow-hidden !p-0">
        <div className="bg-gradient-to-r from-brand-500 to-brand-700 px-6 py-8 text-white">
          <div className="flex items-center gap-3">
            {isApproved ? (
              <MdCheckCircle className="h-10 w-10" />
            ) : (
              <MdHourglassTop className="h-10 w-10" />
            )}
            <div>
              <p className="text-sm font-semibold uppercase tracking-wider text-white/80">
                Vendor onboarding
              </p>
              <h1 className="text-2xl font-bold">
                {isApproved ? "Your account has been approved" : "Approval is pending"}
              </h1>
            </div>
          </div>
        </div>

        <div className="space-y-5 px-6 py-7">
          <p className="text-sm leading-6 text-gray-600 dark:text-gray-300">
            {isApproved
              ? "Sign in again to receive an active vendor session and unlock bot management."
              : "Your organization has been submitted. You can review your profile and account settings while the Plist team reviews your account."}
          </p>

          <div className="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-white/10 dark:bg-white/5">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Account</p>
            <p className="mt-1 font-bold text-navy-700 dark:text-white">
              {account?.email || "Vendor"}
            </p>
            <p className="mt-1 text-sm text-gray-500">
              Status: {isApproved ? "Approved" : "Pending approval"}
            </p>
          </div>

          {error ? <p className="text-sm font-medium text-red-600">{error}</p> : null}

          {isApproved ? (
            <button
              type="button"
              onClick={signInAgain}
              className="w-full rounded-xl bg-brand-500 px-4 py-3 font-semibold text-white transition hover:bg-brand-600"
            >
              Sign in to continue
            </button>
          ) : (
            <button
              type="button"
              onClick={refreshStatus}
              disabled={loading}
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand-500 px-4 py-3 font-semibold text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <MdRefresh className={`h-5 w-5 ${loading ? "animate-spin" : ""}`} />
              {loading ? "Checking..." : "Check approval status"}
            </button>
          )}
        </div>
      </SectionCard>
    </div>
  );
};

export default PendingApproval;
